import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What is the Stageletics Aura Sleeve?",
    a: "Aura Sleeve is a premium cord cover designed for microphone stands. It hides the cables running down your stand — including XLR microphone cables, Allen & Heath ME-1 monitor lines, IEM, and power cords — behind a clean matte black surface for a professional stage look.",
  },
  {
    q: "Will it fit my microphone stand?",
    a: "Aura Sleeve is designed to fit most standard tripod and round-base microphone stands. The adjustable length covers 24-48 inches, accommodating common stand heights. If you have an unusual setup, contact us before ordering.",
  },
  {
    q: "Can it cover the Allen & Heath ME-1 cable?",
    a: "Yes. Aura Sleeve was specifically designed with personal monitor setups like the Allen & Heath ME-1 in mind. It easily covers both the ME-1 Cat5 cable and your wired microphone cable simultaneously.",
  },
  {
    q: "How long does installation take?",
    a: "Just a few minutes. Slide the sleeve over your stand, snap the sections into place, and you're done. No tools required.",
  },
  {
    q: "What's the difference between the single and the bundle?",
    a: "The single ($59) gets you one Aura Sleeve. The bundle of 3 ($159) saves you 10% off three singles and is perfect for outfitting your entire front line (lead vocals, BGV, and acoustic position).",
  },
  {
    q: "How long does shipping take?",
    a: "We hand-pack and ship every order ourselves. Orders typically ship within 2-3 business days, with US delivery in 3-7 business days via standard shipping. Flat-rate shipping is $7.99.",
  },
  {
    q: "Do you ship internationally?",
    a: "Currently we ship within the United States. International shipping is on the roadmap — sign up for product updates to be notified.",
  },
  {
    q: "What if I don't love it?",
    a: "We offer a 30-day return policy. If Aura Sleeve isn't right for your stage, return it in original condition for a full refund (minus return shipping). See our Returns page for full details.",
  },
  {
    q: "Is the material safe under stage lighting?",
    a: "Yes. The matte-black finish is non-reflective by design — no glossy glare to distract during your service. The textured surface diffuses stage lighting rather than bouncing it back.",
  },
  {
    q: "How is the Aura Sleeve made?",
    a: "Each Aura Sleeve is manufactured, packaged, and shipped in-house. We control the entire process to ensure quality.",
  },
];

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="bg-[#050505] text-white pt-32 min-h-screen">
      <div className="px-6 md:px-12 lg:px-24 pb-24 max-w-4xl">
        <p className="eyebrow mb-4">Support</p>
        <h1 className="font-display text-4xl sm:text-5xl font-medium tracking-tight mb-4">
          Frequently asked questions.
        </h1>
        <p className="text-zinc-400 max-w-2xl mb-16 leading-relaxed">
          Everything you need to know about the Aura Sleeve, your order, and
          our shipping policies.
        </p>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-white/10 bg-white/[0.02] px-6"
            >
              <AccordionTrigger className="font-display text-lg font-medium hover:no-underline text-left">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 leading-relaxed text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
